import { FC, ReactNode } from "react";
import { Outlet } from "react-router-dom";
import Navigation from "./Navigation.tsx";
import ErrorBoundary from "../common/ErrorBoundary";
import HPSnackBar from "../common/SnackBar";

interface LayoutProps {
  children?: ReactNode;
}

const Layout: FC<LayoutProps> = ({ children }) => {
  const mainClassName = "w-full flex-1 bg-hp-bg-primary overflow-y-auto";

  return (
    // <div style={layoutStyle}>
    <div className="flex flex-row min-h-screen">
      <ErrorBoundary>
        <Navigation />
      </ErrorBoundary>
      <main className={mainClassName}>
        <ErrorBoundary>{children || <Outlet />}</ErrorBoundary>
      </main>
      {/* Global SnackBar managed by Redux */}
      <HPSnackBar />
    </div>
  );
};

export default Layout;
